module.exports = __webpack_public_path__ + "images/oscar_small90574f51df8f2fb3f63aadf5e169fe17.png";